import React from "react";
import Building from "../assets/building-icon.png";
import trophy from "../assets/trophy-icon.png";
import "../style/text-content.css";

const Content = () => {
  return (
    <div className="Background-container">
      {/* Text Content */}
      <div className="txt-background">
        <div className="container">
          <h3>We’re Applicable to build</h3>
          <div className="image-item">
            <img src={Building} alt="icon" className="Building-img" />
            <span>
              Residential Construction - Custom homes, villas, and apartments
            </span>
          </div>
          <div className="image-item">
            <img src={Building} alt="icon" className="Building-img" />
            <span>
              Commercial Projects - Office buildings, malls, and retail spaces
            </span>
          </div>
          <div className="image-item">
            <img src={Building} alt="icon" className="Building-img" />
            <span>
              Industrial Construction - Factories, warehouses, and
              infrastructure
            </span>
          </div>
          <div className="image-item">
            <img src={Building} alt="icon" className="Building-img" />
            <span>
              Renovation & Remodeling - Transforming spaces with modern designs
            </span>
          </div>
          <div className="image-item">
            <img src={Building} alt="icon" className="Building-img" />
            <span>
              Interior & Exterior Works - Elegant interiors and durable
              exteriors
            </span>
          </div>
          <div className="image-item">
            <img src={Building} alt="icon" className="Building-img" />
            <span>
              Road & Bridge Construction - Quality infrastructure development
            </span>
          </div>
        </div>

        <div className="container">
          <h3>Why choose us</h3>
          <div className="image-item">
            <img src={trophy} alt="icon" className="Building-img" />
            <span>
              Experienced Professionals – Years of expertise in civil
              construction
            </span>
          </div>
          <div className="image-item">
            <img src={trophy} alt="icon" className="Building-img" />
            <span>
              On-Time Delivery – We ensure projects are completed on schedule
            </span>
          </div>
          <div className="image-item">
            <img src={trophy} alt="icon" className="Building-img" />
            <span>
              Quality Assurance – Premium craftsmanship at every level
            </span>
          </div>
          <div className="image-item">
            <img src={trophy} alt="icon" className="Building-img" />
            <span>
              Customer-Centric Approach – Your satisfaction is our priority
            </span>
          </div>
          <div className="image-item">
            <img src={trophy} alt="icon" className="Building-img" />
            <span>Transparent Pricing – No hidden costs, complete clarity</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;
